import { inject } from "vue";

export const ConfirmDialog = {
  // ---------------- generic
  confirm: (swal, config = {}) => {
    const defaultConfig = {
      title: "¿Está seguro?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      focusCancel: true,
      reverseButtons: true,
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //------------------------create event
  confirmCreate: (swal) => {
    return ConfirmDialog.confirm(swal, {
      title: "¿Está seguro?",
      text: "Se registrará un nuevo evento.",
      confirmButtonText: "Registrar Evento",
    });
  },

  //--------------------update event
  confirmUpdate: (swal) => {
    return ConfirmDialog.confirm(swal, {
      title: "¿Está seguro?",
      text: "Se actualizará el evento.",
      confirmButtonText: "Actualizar Evento",
    });
  },

  //-------------------------delete event
  confirmDelete: (swal, itemName = "el elemento") => {
    return ConfirmDialog.confirm(swal, {
      title: "¿Eliminar?",
      text: `Se eliminará ${itemName}. Esta acción no se puede deshacer.`,
      confirmButtonText: "Eliminar",
      confirmButtonColor: "#d33",
      icon: "error",
    });
  },

  //----------------------------generic success
  success: (swal, config = {}) => {
    const defaultConfig = {
      icon: "success",
      confirmButtonText: "Aceptar",
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //-----------------------------create success
  successCreate: (swal, itemName = "el registro") => {
    return ConfirmDialog.success(swal, {
      title: "Registro Exitoso",
      text: `${itemName} se registró de manera exitosa`,
    });
  },

  //-----------------------------update success
  successUpdate: (swal, itemName = "el registro") => {
    return ConfirmDialog.success(swal, {
      title: "Actualización Exitosa",
      text: `${itemName} se actualizó correctamente`,
    });
  },

  //-----------------generic error
  error: (swal, config = {}) => {
    const defaultConfig = {
      icon: "error",
      confirmButtonText: "Aceptar",
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //-----------------------create error
  errorCreate: (swal) => {
    return ConfirmDialog.error(swal, {
      title: "Registro fallido",
      text: "El registro no se completó de manera exitosa",
    });
  },

  //---------------------------update error
  errorUpdate: (swal) => {
    return ConfirmDialog.error(swal, {
      title: "Error en la actualización",
      text: "No se pudo actualizar el registro",
    });
  },

  //--------------------------form incomplete
  incompleteForm: (swal) => {
    return ConfirmDialog.error(swal, {
      title: "Formulario incompleto",
      text: "Por favor, complete todos los campos obligatorios.",
    });
  },

  //----------------------generic warning
  warning: (swal, config = {}) => {
    const defaultConfig = {
      icon: "warning",
      confirmButtonText: "Aceptar",
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //---------------------------generic info
  info: (swal, config = {}) => {
    const defaultConfig = {
      icon: "info",
      confirmButtonText: "Aceptar",
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //--------------------------- required input
  prompt: (swal, config = {}) => {
    const defaultConfig = {
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value) {
          return "Este campo es requerido";
        }
      },
      ...config,
    };

    return swal.fire(defaultConfig);
  },

  //--------------------------- toast success
  toast: (swal, config = {}) => {
    const Toast = swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", swal.stopTimer);
        toast.addEventListener("mouseleave", swal.resumeTimer);
      },
    });

    return Toast.fire({
      icon: "success",
      title: "Operación exitosa",
      ...config,
    });
  },
};

export function useConfirmDialog() {
  const swal = inject("$swal");

  return {
    confirm: (config) => ConfirmDialog.confirm(swal, config),
    confirmCreate: () => ConfirmDialog.confirmCreate(swal),
    confirmUpdate: () => ConfirmDialog.confirmUpdate(swal),
    confirmDelete: (itemName) => ConfirmDialog.confirmDelete(swal, itemName),
    success: (config) => ConfirmDialog.success(swal, config),
    successCreate: (itemName) => ConfirmDialog.successCreate(swal, itemName),
    successUpdate: (itemName) => ConfirmDialog.successUpdate(swal, itemName),
    error: (config) => ConfirmDialog.error(swal, config),
    errorCreate: () => ConfirmDialog.errorCreate(swal),
    errorUpdate: () => ConfirmDialog.errorUpdate(swal),
    incompleteForm: () => ConfirmDialog.incompleteForm(swal),
    warning: (config) => ConfirmDialog.warning(swal, config),
    info: (config) => ConfirmDialog.info(swal, config),
    prompt: (config) => ConfirmDialog.prompt(swal, config),
    toast: (config) => ConfirmDialog.toast(swal, config),
  };
}
